export const route = {
    searchParams: {
        profileJobId: 'profileJobId',
        profilePreviewType: 'profilePreviewType',
        profilePreviewUserId: 'profilePreviewUserId',
    },
};
